/**
 * @internal
 */
export enum DialogPaths {
    quickDialog = 'dist/quick-dialog/', // quick-dialog
    eavUi = 'dist/ng-edit/', // Angular
}
